export enum ProfileType {
  LEGAL = 'LEGAL',
  NATURAL = 'NATURAL',
}

export enum ProfileStatus {
  NEW = 'NEW',
  VERIFIED = 'VERIFIED',
  BLOCKED = 'BLOCKED',
  ARCHIVED = 'ARCHIVED',
  REJECTED = 'REJECTED',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
